var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomChart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 16 16",
    height: "16px",
    id: "Layer_1",
    viewBox: "0 0 24 24",
    width: "24px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,20.3L21.2,18c0.6-0.7,0.9-1.7,0.9-2.6c0-2.1-1.5-3.8-3.5-4.1v-3c0-0.3-0.2-0.5-0.5-0.5h-5.3V2.5 c0-0.3-0.2-0.5-0.5-0.5H6.6C6.3,2,6.1,2.2,6.1,2.5v10.6H0.8c-0.3,0-0.5,0.2-0.5,0.5v9c0,0.3,0.2,0.5,0.5,0.5h17.3 c0.3,0,0.5-0.2,0.5-0.5v-3c0.7-0.1,1.4-0.4,2-0.9l2.3,2.3c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1 C23.7,20.8,23.7,20.5,23.5,20.3z M6.1,22.1H1.3V14h4.9V22.1z M11.9,22.1H7v-8.6V2.9h4.9V22.1z M20.2,17.7c-0.6,0.6-1.4,1-2.3,1 c-1.1,0-2.2-0.6-2.8-1.5c-0.1-0.2-0.4-0.3-0.6-0.1c-0.2,0.1-0.3,0.4-0.1,0.6c0.7,1.1,2,1.8,3.3,1.9v2.5h-4.9V8.6h4.9v2.5 c-1.3,0.1-2.6,0.8-3.3,1.9c-0.1,0.2-0.1,0.5,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1c0.6-0.9,1.6-1.5,2.8-1.5c1.8,0,3.3,1.5,3.3,3.3 C21.2,16.2,20.9,17.1,20.2,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2,14.8c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5 C14.7,15.1,14.5,14.8,14.2,14.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomChart);
export default __webpack_public_path__ + "static/media/custom_chart.f5299f19306f6faa0eb5f42398dac229.svg";
export { ForwardRef as ReactComponent };